import { Datetime, getClasses } from '@/utils';
import { ForwardRefExoticComponent, forwardRef, useCallback } from 'react';

import SimpleTableCell from '@/components/SimpleTable/SimpleTableCell';
import SimpleTableRow from '@/components/SimpleTable/SimpleTableRow';
import { useSummaryHistory } from '../..';
import { useSummaryHistoryDrawer } from '../SummaryHistoryDrawer';

const SummaryHistoryTableRow = ({ id }: { id: string }, ref: ForwardRefExoticComponent<HTMLDivElement>): JSX.Element => {
  const [{ summary, selected }, setState] = useSummaryHistory(({ summaries, selected }) => ({
    summary: summaries.get(id),
    selected: selected.has(id),
  }));
  const setSummaryHistoryDrawer = useSummaryHistoryDrawer(({ setState }) => setState);

  const onSelect = useCallback(
    (): void =>
      setState((current) => {
        const newSelected = new Map(current.selected);
        if (newSelected.has(id)) newSelected.delete(id);
        else newSelected.set(id, current.summaries.get(id));
        return { ...current, selected: newSelected };
      }),
    [summary, id, setState]
  );
  const onEdit = (): void => {
    setSummaryHistoryDrawer((current) => ({
      ...current,
      show: true,
      data: summary,
    }));
  };

  return (
    <SimpleTableRow id={id} className={getClasses(selected ? 'SELECTED' : undefined)} onDoubleClick={onEdit} ref={ref}>
      <SimpleTableCell.Select checked={selected} onChange={onSelect} />
      <SimpleTableCell name="CREATED_AT">{new Datetime().setAsUTC(summary.createdAt).toLocaleDatetime().frontendDatetime}</SimpleTableCell>
      <SimpleTableCell name="DISPATCHER">{[summary.dispatcherFirstName, summary.dispatcherLastName].join(' ')}</SimpleTableCell>
      <SimpleTableCell name="SHIFT">{summary.dispatcherShift}</SimpleTableCell>
      <SimpleTableCell name="CALL_VOLUME">{summary.callVolume}</SimpleTableCell>
    </SimpleTableRow>
  );
};

export default forwardRef(SummaryHistoryTableRow);
